module.exports = __webpack_public_path__ + "static/media/CARA_3.6ef4cb8e.png";